import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { SidebarModalListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import usePublicationOptionValue from '@hooks/usePublicationOptionValue'

const confirmDelete = (deletePublicationOptionValue, deleteFn) => {
  const publicationOptionValuePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Publication Option Value Deleted',
  }

  swal
    .fire({
      title: 'Delete Publication Option Value?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        deletePublicationOptionValue(publicationOptionValuePayload)
      }
    })
}

const PublicationOptionValueListItem = (props) => {
  const {
    publicationOptionValue,
    publicationOptionValue: {
      title,
      value,
    },
  } = props

  const { callbacks } = useContext(PageContext)
  const { deletePublicationOptionValue } = callbacks || {}

  const publicationOptionValuePayload = usePublicationOptionValue(publicationOptionValue)
  const {
    callbacks: {
      deletePublicationOptionValue: deleteFn,
    },
  } = publicationOptionValuePayload

  return (
    <SidebarModalListItem
      secondaryText={value}
      title={title}
    >
      <SidebarModalListItem.Actions>
        <SidebarModalListItem.Icon
          onClick={() => confirmDelete(deletePublicationOptionValue, deleteFn)}
          type="delete"
        />
      </SidebarModalListItem.Actions>
    </SidebarModalListItem>
  )
}

PublicationOptionValueListItem.propTypes = {
  publicationOptionValue: PropTypes.object.isRequired,
}

export default PublicationOptionValueListItem
